import { BASE_URL, deleteRequest, post, put, get, PageResult } from "./Common";

export type WeeklyReportDay =
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY"
  | "SUNDAY";

export interface ReportSubscription {
  id?: number;
  managerName: string;
  managerEmail: string;
  dailyOptIn: boolean;
  weeklyOptIn: boolean;
}

export interface AdminInfo {
  adminId: number;
  name: string;
  email: string;
  phone: string;
  enabled: boolean;
  networks: AdminInfoNetworkInfo[];
  identities: string[];
}

export interface AdminInfoNetworkInfo {
  networkId: number;
  name: string;
}

export const createReportSubscription = async (
  l1Id: number,
  subscription: ReportSubscription,
  authToken: string,
) => {
  const url = `${BASE_URL}/networks/${l1Id}/report_subscriptions`;

  try {
    await post(url, authToken, undefined, subscription);
    return true;
  } catch (Error) {
    return false;
  }
};

export const updateReportSubscription = async (
  l1Id: number,
  subscription: ReportSubscription,
  authToken: string,
) => {
  const url = `${BASE_URL}/networks/${l1Id}/report_subscriptions/${subscription.id}`;

  try {
    await put(url, authToken, undefined, subscription);
    return true;
  } catch (Error) {
    return false;
  }
};

export const deleteReportSubscription = async (l1Id: number, subscriptionId: number, authToken: string) => {
  const url = `${BASE_URL}/networks/${l1Id}/report_subscriptions/${subscriptionId}`;

  return deleteRequest(url, authToken);
};

export const getWeeklyReportDay = async (l1Id: number, authToken: string) => {
  const url = `${BASE_URL}/networks/${l1Id}/weekly_report_day`;
  const response = await get<{ day: WeeklyReportDay | null }>(url, authToken);
  return response.parsedBody?.day ?? null;
};

export const setWeeklyReportDay = async (
  l1Id: number,
  day: WeeklyReportDay,
  authToken: string,
) => {
  const url = `${BASE_URL}/networks/${l1Id}/weekly_report_day`;
  try {
    await post(url, authToken, undefined, { day });
    return true;
  } catch (Error) {
    return false;
  }
};

export const getAdminUsers = async (nameFilter: string | null, page: number, authToken: string) => {
  let url = `${BASE_URL}/access/search?page=${page}`;

  if (nameFilter) {
    url = `${url}&nameFilter=${nameFilter}`;
  }

  const httpResponse = await get<PageResult<AdminInfo>>(url, authToken);

  return httpResponse.parsedBody;
};
